import { styledTag } from 'src/utils/styled';

export const LegalContent = styledTag('main')`
    max-width: 1160px;
    margin: auto;
    padding: 2rem 1rem;
`;
